<div class="card-body" *ngIf="!moduledisplay">
  <ul class="list-group list-group-flush list my--3">
    <li class="list-group-item px-0" *ngFor="let tutor of tutorList">
      <app-adminuser [tutor]="tutor" [showbuttons]="showbuttons" [moduledisplay]="moduledisplay"
        (manageuser)="manageuserclicked($event)"></app-adminuser>
    </li>
  </ul>
</div>

<div *ngIf="moduledisplay" class="tutor-list gap-2.5 d-flex flex-wrap">
    <app-adminuser *ngFor="let tutor of tutorList" [tutor]="tutor" [showbuttons]="showbuttons" [moduledisplay]="moduledisplay"
      (manageuser)="manageuserclicked($event)"></app-adminuser>
</div>
